import { api } from './api';

export interface LoginResponse {
  success: boolean;
  message: string;
  access_token?: string;
  refresh_token?: string;
  user?: any;
}

export const login = async (email: string, password: string): Promise<LoginResponse> => {
  try {
    const response = await api.post('/auth/login', {
      email,
      password,
    });

    return response.data;
  } catch (error: any) {
    console.log("Login Error:", error);

    // API returned error response
    if (error.response) {
      return {
        success: false,
        message: error.response.data?.message || 'Invalid email or password',
      };
    }

    // Network error only
    return {
      success: false,
      message: 'Could not reach server. Please try again.',
    };
  }
};
